import { usePreferences } from "../context/PreferencesContext";
import { TRANSLATIONS } from "./dictionary";

// Flat English -> Marathi phrase-table translator. Any component can call
// t("Some English string") and get the Marathi equivalent back when the
// user has switched languages, or the original string unchanged when no
// translation exists yet (safe no-op fallback — never throws, never blanks
// the UI on a missing entry). Non-string values (numbers, JSX, null) pass
// through untouched so it's safe to wrap render call sites indiscriminately.
export function useTranslate() {
  const { lang } = usePreferences();
  return (text) => {
    if (lang !== "mr" || typeof text !== "string") return text;
    return TRANSLATIONS[text] ?? text;
  };
}
